module.exports = __webpack_public_path__ + "static/media/gym_03.2bb5f5b9.png";